<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Deduction or Earnings"
      text="Create deduction or earning"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="code"
                v-validate="'required'" 
                label="Code"
                :error-messages="errors.collect('code')"
                data-vv-name="code"    
                data-vv-as="code" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-8"
            >
              <tiptap-vuetify
                v-model="description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="payrollCycle" 
                v-validate="'required'"
                :error-messages="errors.collect('payrollCycle')"    
                data-vv-name="payrollCycle" 
                data-vv-as="payroll cycle"
                label="Payroll Cycle"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
                outlined
                :items="payrollCycles"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">[{{ data.item.code }}] - {{ data.item.name }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="doeCategory" 
                v-validate="'required'"
                :error-messages="errors.collect('doeCategory')"    
                data-vv-name="doeCategory" 
                data-vv-as="doe category"
                label="DOE Category"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
                :items="doeCategories"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">[{{ data.item.code }}] - {{ data.item.name }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="cutoffType" 
                v-validate="'required'"
                :error-messages="errors.collect('cutoffType')"    
                data-vv-name="cutoffType" 
                data-vv-as="cutoff type"
                label="Cutoff Types"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
                :items="cutoffTypes"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">[{{ data.item.code }}] - {{ data.item.name }}</span>
                    <span
                      style="width:100px"
                      v-html="data.item.description"
                    />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="taxExemption" 
                label="Tax Exemption"
                item-text="name"
                item-value="id"
                :items="taxExemptions"
                outlined
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="eaClass"
                v-validate="'required'"
                :error-messages="errors.collect('eaClass')"    
                data-vv-name="eaClass" 
                data-vv-as="ea class"
                label="EA class"
                outlined
                :items="eaItems"
                item-text="text"
                item-value="value"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"
              md="6"
              sm="6"
              xl="4"
            >
              <span>Is Taxable? </span>
              <v-radio-group
                v-model="isTaxable"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span> Is EPF? </span>
              <v-radio-group
                v-model="isEpf"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
           
            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span>Is EIS? </span>
              <v-radio-group
                v-model="isEis"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              md="6"
              xl="4"
              sm="6"
            >
              <span> Is Socso? </span>
              <v-radio-group
                v-model="isSocso"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"
              md="6"
              sm="6"
              xl="4"
            >
              <span>Is HRDF? </span>
              <v-radio-group
                v-model="isHrdf"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
        
            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span>Is Negative? </span>
              <v-radio-group
                v-model="isNegative"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="!isNegative"
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span> Is Additional Remuneration? </span>
              <v-radio-group
                v-model="isAdditionalRemuneration"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        code: null,
        description: null,
        cutoffTypes: [],
        cutoffType: null,
        doeCategories: [],
        doeCategory: null,
        payrollCycle: null,
        payrollCycles: [],
        isProrated: 0,
        isGetFullAmount: 0,
        isNegative: 0,
        isEpf: 0,
        isEis: 0,
        isRetirementBenefit: 0,
        isGratuity: 0,
        isSocso: 0,
        isHrdf: 0,
        isAdditionalRemuneration: 0,
        isTaxable: 0,
        eaClass: null,
        name: null,
        taxClass: null,
        taxExemption: null,
        taxExemptions: [],
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        eaItems: [
          { value: 'gross_wages_leave_pay', text: 'gross_wages_leave_pay' },
          { value: 'allowance', text: 'allowance' },
          { value: 'fee', text: 'fee' },
          { value: 'commission', text: 'commission' },
          { value: 'bonus', text: 'bonus' },
          { value: 'tips_perquisites_awards', text: 'tips_perquisites_awards' },
          { value: 'overtime', text: 'overtime' },
          { value: 'tax_borne_by_employer', text: 'tax_borne_by_employer' },
          { value: 'esos', text: 'esos' },
          { value: 'arrears', text: 'arrears' },
          { value: 'pension', text: 'pension' },
          { value: 'annuities', text: 'annuities' },
          { value: 'levy', text: 'levy' },
          { value: 'zakat', text: 'zakat' },
          { value: 'compensation', text: 'compensation' },
          { value: 'refund', text: 'refund' },
          { value: 'gratuity', text: 'gratuity' },
          { value: 'cp38', text: 'cp38' },
          { value: 'none', text: 'None of the above (won\'t include the amount in EA)' },
        ],
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true

        Promise.all([
          this.$api.cutoffTypes().list(),
          this.$api.doeCategories().list(),
          this.$api.taxExemptions().list({ year: this.yearFilter }),
          this.$api.hrisPayrollCycles().list(),
        ])
          .then(([cutoffType, doeCategory, taxExemptions, payrollCycles]) => {
            this.cutoffTypes = _.orderBy(cutoffType.data, ['code'], ['asc'])    
            this.doeCategories = _.orderBy(doeCategory.data, ['code'], ['asc'])    
            this.taxExemptions = _.orderBy(taxExemptions.data, ['code'], ['asc'])
            this.payrollCycles = _.orderBy(payrollCycles.data, ['code'], ['asc']) 
            
            this.loading = false
          })
      },
    },

    methods: { 
      prepareFormData () {
        return {
          code: this.code,
          name: this.name,
          description: this.description,
          payroll_cycle_id: this.payrollCycle,
          cutoff_type_id: this.cutoffType,
          doe_category_id: this.doeCategory,
          is_epf: this.isEpf,
          is_negative: this.isNegative,
          is_eis: this.isEis,
          is_socso: this.isSocso,
          is_hrdf: this.isHrdf,
          is_additional_remuneration: this.isNegative ? 0 : this.isAdditionalRemuneration,
          ea_class: this.eaClass,
          tax_exemption_id: this.taxExemption,
          is_taxable: this.isTaxable,

          // not used //
          tax_class: this.taxClass,
          is_prorated: this.isProrated,
          is_get_full_amount: this.isGetFullAmount,
          is_retirement_benefit: this.isRetirementBenefit,
          is_gratuity: this.isGratuity,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.deductionOrEarnings().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: 'DoE created' })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
